module.exports = __webpack_public_path__ + "img/img.26efe9ab.png";